import { DEVICE_TYPE, TRANSFER_MODE } from '../../root/constants.js'

export const hasHeartbeatIntervalSetting = (deviceType, transferMode) =>
    deviceType !== DEVICE_TYPE['tm01-1'] &&
    deviceType !== DEVICE_TYPE.trapsensor &&
    !(
        deviceType === DEVICE_TYPE['jerry-lora'] &&
        transferMode === TRANSFER_MODE.lora
    )
